import { type ReactNode } from "react";
import { motion } from "motion/react";
import { LoaderCircle } from "lucide-react";

import { cn, getText } from "shared/lib";
import { animationVariants } from "./lib";

export interface AnalysisMenuItemProps {
  icon: ReactNode;
  isLoading?: boolean;
  label: ReactNode;
  onClick?: () => void;
  selected?: boolean;
  subLabel?: ReactNode;
}

export function AnalysisMenuItem({
  icon,
  isLoading,
  label,
  onClick,
  selected,
  subLabel,
}: AnalysisMenuItemProps) {
  return (
    <motion.li
      className={cn(
        "border-interfaceBorder cursor-pointer overflow-clip border-b p-3 [transform-origin:left]",
        selected && "bg-blueBgDefault border-b-blueBorder",
      )}
      onClick={onClick}
      role="menuitem"
      variants={animationVariants}
    >
      <div className="flex h-10 items-center gap-2">
        {icon}
        <div className="flex flex-col">
          <span
            className={
              selected ? "text-headingmd font-semibold" : "text-bodylg"
            }
          >
            {label}
          </span>
          {isLoading ? (
            <p className="text-textSubdued text-bodysm flex items-center gap-0.5">
              <LoaderCircle className="h-3 w-3 animate-spin" />
              {getText("Generating")}
            </p>
          ) : (
            subLabel
          )}
        </div>
      </div>
    </motion.li>
  );
}
